import React, { useEffect, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import Header from '../Header';
import Footer from '../Footer';
import Sidebar from '../Sidebar';
import { useLayout } from '../../contexts/LayoutContext';
import LandingPage, { banners } from '../../pages/LandingPage';

const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  width: 100%;
  overflow-x: hidden;
`;

const ContentContainer = styled.div<{ mobilePadding?: string }>`
  display: flex;
  flex: 1;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: ${({ theme }) => theme.spacing.lg} ${({ theme }) => theme.spacing.md};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: ${({ theme }) => theme.spacing.md};
  }
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    padding: ${({ mobilePadding }) => mobilePadding};
  }
`;

const MainContent = styled.main`
  flex: 1;
`;

const SidebarContainer = styled.div`
  width: 280px;
  margin-right: 20px;
  
  @media (max-width: 1024px) {
    width: 220px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: none;
  }
`;


const pagesNoPaddingPaths = ['/Q', '/W', '/E', '/R', '/T', '/Y', '/U', '/I', '/O', '/P', '/A', '/S', '/D', '/F', '/G', '/H', '/J', '/K', '/L', '/Z', '/X', '/C', '/V', '/B', '/N', '/M'];
const Layout: React.FC = () => {
  const { showSidebar } = useLayout();
  const location = useLocation();

  const mobilePadding = pagesNoPaddingPaths.find(path => location.pathname.includes(path)) ? "0" : "0.5rem";

  const isQPage = useMemo(()=>{
    for(const banner of banners){
      if(location.pathname.startsWith(`/${banner}`) && !location.pathname.startsWith(`/${banner}EVENT`)){
        return true;
      }
    }
    return false;
  },[location.pathname]);

  const hostname = window.location.hostname;

  // if () {
  //   return (
  //     <LayoutContainer>
  //       <LandingPage />
  //     </LayoutContainer>
  //   );
  // }

  if(hostname === "xn--c79ay38b92b12b.com" || hostname === "xn--le5b23cccq68e.com"){
    return (
      <LayoutContainer>
        <Header />
        <ContentContainer mobilePadding={mobilePadding || "0"}>
          {showSidebar && (
            <SidebarContainer>
              <Sidebar />
            </SidebarContainer>
          )}
          <MainContent>
            <LandingPage />
          </MainContent>
        </ContentContainer>
        <Footer />
      </LayoutContainer>
    )
  }
  
  if (isQPage) {
    return (
      <LayoutContainer>
        <Outlet />
      </LayoutContainer>
    );
  }

  return (
    <LayoutContainer>
      <Header />
      <ContentContainer mobilePadding={mobilePadding || "0"}>
        {showSidebar && (
          <SidebarContainer>
            <Sidebar />
          </SidebarContainer>
        )}
        <MainContent>
          <Outlet />
        </MainContent>
      </ContentContainer>
      <Footer />
    </LayoutContainer>
  );
};

export default Layout; 